<i18n src="@/locales/modules/TodoListTranslate.json"></i18n>

<template>
    <div class="cbs-quick-config-children-todo">
        <div class="p-3 sm:p-6 bg-gray-7 mb-5" v-for="(item, index) in localValue" :key="index">
            <quick-config-todo-item
                v-model="localValue[index]"
                :todoType="todoType"
                :parentId="parentId"
                :formName="`cbs-quick-config-children-todo-${index}`"
            />
            <div class="flex mt-5 justify-end" v-if="!item.id && localValue.length > 1">
                <i class="nucleo nucleo-trash-can cursor-pointer text-lg" @click.stop="showDeleteConfirm(index)" />
            </div>
        </div>

        <span
            class="footer__btn-add text-lg rounded text-gray-2 border border-dashed border-gray-4 px-3 flex items-center justify-center cursor-pointer hover:border-gray-3 hover:font-bold"
            @click="$emit('onClickAddTodoItem')"
        >{{ $t("AddDetail") }}</span>
    </div>
</template>

<script>
import { showConfirm } from "@/mixins/mixins.js";

import QuickConfigTodoItem from "./QuickConfigTodoItem";

export default {
    name: "CbsQuickConfigChildrenTodo",
    mixins: [showConfirm],
    components: {
        QuickConfigTodoItem
    },
    props: {
        value: {
            type: Array,
            required: true
        },
        todoType: {
            type: Number,
            required: true
        },
        parentId: {
            type: Number,
            required: true
        }
    },
    emits: {
        onClickAddTodoItem: {},
        onClickRemoveTodoItem: {}
    },
    computed: {
        localValue: {
			get() {
				return this.value;
			},
			set(val) {
				this.$emit("input", val);
			}
		},
    },
    methods: {
        showDeleteConfirm(optionIndex) {
			this.mixinShowConfirm().then(isAccept => {
				if (isAccept) {
                    this.$emit("onClickRemoveTodoItem", optionIndex);
				}
			});
		}
    }
}
</script>

<style lang="scss" scoped>
.cbs-quick-config-children-todo {
    .footer__btn-add {
        height: 40px;
    }
}
</style>